import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import Nav from '../Nav'
import Dashboard from '../Dashboard';
import Users from '../Users';
import TimeSlot from '../TimeSlot';
import Branch from '../Branch';
import { setLoggedInUser } from '../../features/auth/authSlice';
import { getUsersFromUsersTableById } from "../../api/reusableApis";
import Profile from '../Profile';
import Modal from "../../components/modal";
import Booking from '../Booking';
import Addons from '../Addons';
import { setActiveItem } from '../../features/nav/navSlice';
import Packages from '../Packages';
import Bookings from '../Bookings';
import ListBookings from '../ListBookings';
function AdminLayout() {

  const activeItem = useSelector((state) => state.nav.activeItem);
  const selectedItem = useSelector((state) => state.logout.selectedItem)

  const dispatch = useDispatch();
  const currentLoggedInUser = useSelector((state) => state.auth.currentUser);
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  useEffect(() => {
    console.log(currentLoggedInUser, 'currentLoggedInUser');
    var userManagement = window.catalyst.auth;
    var currentUserPromise = userManagement.isUserAuthenticated();
    currentUserPromise.then(async (response) => {
      console.log(response, 'response');
      if (response['status'] === 200) {
        var data = response['content'];
        if (data && data['status'] === "ACTIVE" && data['role_details']['role_name'] === 'App User') {
          console.log("You don't have access to the admin's page.");
          setIsUserAuthenticated(false);
        } else if (data && data['status'] === "ACTIVE" && data['role_details']['role_name'] === 'App Administrator') {
          const userDetails = await getUsersFromUsersTableById(data['user_id']);
          console.log(userDetails, 'userDetails');
          if (userDetails['success']) {
            data['users'] = userDetails['user'];
          }
          setIsUserAuthenticated(true);
          dispatch(setLoggedInUser(data));
        }
      }
    }).catch((err) => {
      console.log("Kindly login to the application. - admin..")
      setIsUserAuthenticated(false);
    });
  }, []);


  const pageContent = () => {
    // Hide content during logout modal
    if (activeItem === 'Logout') return null;

    switch (activeItem) {
      case 'Dashboard': return <Dashboard />;
      case 'Manage users': return <Users />;
      case 'Manage Branch': return <Branch />;
      case "Addon's": return <Addons />;
      case 'Profile': return <Profile />;
      case "Packages": return <Packages />;
      case "Manage time-slots": return <TimeSlot />;
      case "Create Booking": return <Bookings />;
      case "List Bookings": return <ListBookings />;
      case "Booking Table": return <Booking />;
      default: return <Dashboard />;
    }
  };

  useEffect(() => {
    console.log(activeItem);
    if (activeItem === 'Logout') {
      setShowLogoutModal(true);
    }
  }, [activeItem]);

  const confirmLogout = () => {
    dispatch(setActiveItem('Dashboard'));
    setShowLogoutModal(false);
    logout();
  };

  const cancelLogout = () => {
    dispatch(setActiveItem('Profile')); // or store previous item
    setShowLogoutModal(false);
  };

  function logout() {
    const redirectURL = '/__catalyst/auth/login';
    window.catalyst.auth.signOut(redirectURL);
  }


  return (
    <>
      
          <div className="min-h-screen bg-[#F7F9FC] flex font-sans">
            <Nav />
            {pageContent()}
          </div>

          <Modal
            open={showLogoutModal}
            onClose={cancelLogout}
            title="Confirm Logout"
            width="w-full sm:w-96 p-6"
          >
            <div className="space-y-4 text-center py-4">
              <div className="text-lg font-semibold text-gray-900 mb-2">
                Are you sure you want to logout?
              </div>
              <p className="text-sm text-gray-600 mb-6">
                You will be redirected to the login page.
              </p>
              <div className="flex gap-3 justify-center">
                <button
                  onClick={cancelLogout}
                  className="px-6 py-2 edit-btn text-xs m-[10px] font-medium flex-1 max-w-xs"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmLogout}
                  className="px-6 py-2 primary-btn text-xs m-[10px] font-medium flex-1 max-w-xs shadow-sm"
                >
                  Logout
                </button>
              </div>
            </div>
          </Modal>
        </>
  )
}

export default AdminLayout;